import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  getCategoryIsEarlyAccess,
  getCategoryDetails,
  getIsEarlyAccessCategoryComingSoon,
} from "../../state/modules/category";
import { getViewportCategory } from "../../state/modules/layout/selectors";
import {
  getCategoryDetailsFeaturedHeaderData,
  getCategoryDetailsFeaturedHeaderEnabled,
  getCategorySeoLinks,
  getCategoryVisualCategories,
} from "../../state/modules/category/selectors";

import loadable from "@loadable/component";
import CategoryHeader from "./CategoryHeader";
import getMediaUrls from "../EarlyAccessCategoryHeader/getMediaUrls";
import getMediaType from "../EarlyAccessCategoryHeader/getMediaType";

const EarlyAccessCategoryHeader = loadable(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "CATEGORY_HEADER_VARIANT" */ "../EarlyAccessCategoryHeader"
    ),
  { fallback: null },
);

const FeaturedCategoryHeader = loadable(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "CATEGORY_HEADER_VARIANT" */ "../FeaturedCategoryHeader"
    ),
  { fallback: null },
);

const CategoryHeaderContainer = ({
  scrollFunction,
  hideDescription = false,
}) => {
  const isEarlyAccess = useSelector(getCategoryIsEarlyAccess);
  const category = useSelector(getCategoryDetails);
  const viewportCategory = useSelector(getViewportCategory);
  const isComingSoon = useSelector(getIsEarlyAccessCategoryComingSoon);
  const isFeaturedHeader = useSelector(getCategoryDetailsFeaturedHeaderEnabled);
  const featuredHeaderData = useSelector(getCategoryDetailsFeaturedHeaderData);
  const mediaUrls = getMediaUrls(featuredHeaderData);
  const mediaType = getMediaType({ viewportCategory, mediaUrls });
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);
  const visualCategories = useSelector(getCategoryVisualCategories);
  const hasVisualCategories = visualCategories.length > 0;
  const hasHeaderLinks = !!primarySeoLinks.length && !hasVisualCategories;

  const renderEarlyAccessHeader = () => (
    <EarlyAccessCategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      category={category}
      mediaType={mediaType}
      viewportCategory={viewportCategory}
      isComingSoon={isComingSoon}
      scrollFunction={scrollFunction}
    />
  );

  const renderFeaturedHeader = () => (
    <FeaturedCategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      hasVisualCategories={hasVisualCategories}
      hideDescription={hideDescription}
      category={category}
      mediaType={mediaType}
      viewportCategory={viewportCategory}
      scrollFunction={scrollFunction}
      featuredHeaderData={featuredHeaderData}
    />
  );

  const renderDefaultHeader = () => (
    <CategoryHeader
      hasHeaderLinks={hasHeaderLinks}
      hasVisualCategories={hasVisualCategories}
      hideDescription={hideDescription}
    />
  );

  if (isEarlyAccess) {
    return renderEarlyAccessHeader();
  } else if (isFeaturedHeader) {
    return renderFeaturedHeader();
  } else {
    return renderDefaultHeader();
  }
};

CategoryHeaderContainer.propTypes = {
  scrollFunction: PropTypes.func.isRequired,
  hideDescription: PropTypes.bool,
};

export default CategoryHeaderContainer;
